import { put } from 'redux-saga/effects';

import { InsighttNotification } from '../../helpers/insightt-notification';
import AppActions from '../actions/app.actions';

export function* getBranchesRequest(api) {
  const response = yield api.getBranches(false);
  if (response && response.ok) {
    yield put(AppActions.getBranchesSuccess(response.data));
  } else {
    yield put(AppActions.getBranchesFailure());
  }
}

export function* getRolesRequest(api) {
  const response = yield api.getRoles();
  if (response && response.ok) {
    yield put(AppActions.getRolesSuccess(response.data));
  } else {
    yield put(AppActions.getRolesFailure());
  }
}

export function* getAlertsRequest(api) {
  const response = yield api.getAlerts();
  if (response && response.ok) {
    yield put(AppActions.getAlertsSuccess(response.data));
  } else {
    yield put(AppActions.getAlertsFailure());
  }
}

export function* toggleAlertRequest(api, action) {
  const { payload } = action;
  const response = yield api.toggleAlert(payload);
  if (response && response.ok) {
    yield put(AppActions.toggleAlertSuccess(response.data));
  } else {
    yield put(AppActions.toggleAlertFailure(payload));
  }
}

export function* getServerTimeRequest(api) {
  const response = yield api.getServerTime();
  if (response && response.ok) {
    yield put(AppActions.getServerTimeSuccess(response.data));
  } else {
    yield put(AppActions.getServerTimeFailure());
  }
}

export function* setServerTimeRequest(api, action) {
  const { payload } = action;
  const response = yield api.setServerTime(payload);
  if (response && response.ok) {
    InsighttNotification('success', 'Server Time was updated successfully', response);
    yield put(AppActions.setServerTimeSuccess(response.data));
  } else {
    InsighttNotification('error', 'Unable to set Server Time', response);
    yield put(AppActions.setServerTimeFailure(payload));
  }
}
